import React from "react";
import logo from "../../images/logo/logo-black.png";
import "./UnderConstructionPage.css";

const UnderConstructionPage = () => {
  return (
    <div className="uc-wrapper-light">
      <div className="uc-container-simple">
        {/* BUGA MONEY Logo */}
        <div className="uc-logo-wrap">
          <img src={logo} alt="BUGA MONEY" className="uc-logo-light" />
        </div>

        {/* Simple Text Content */}
        <div className="uc-content-simple">
          <h1 className="uc-title-simple">Under Construction</h1>
          <p className="uc-text-simple">
            Our website is currently undergoing scheduled maintenance and updates. 
            We will be back shortly with an improved experience.
          </p>

          <div className="uc-divider"></div>

          <div className="uc-contact-simple">
            <p>
              For inquiries or assistance, please reach out to us:
            </p>
            <p className="uc-contact-line">
              <strong>Email:</strong> <a href="mailto:info@bugamoney.com">info@bugamoney.com</a>
            </p>
            <p className="uc-contact-line">
              <strong>WhatsApp:</strong>{" "}
              <a
                href="https://wa.me/447948972125?text=Hello%20I%20want%20to%20know%20more%20about%20your%20money%20transfer%20services"
                target="_blank"
                rel="noopener noreferrer"
              >
                07948972125
              </a>
            </p>
          </div>
        </div>

        {/* Footer */}
        <footer className="uc-footer-simple">
          <p>© {new Date().getFullYear()} BUGA MONEY. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default UnderConstructionPage;
